module.exports = __webpack_public_path__ + "static/media/getwoke.efc8a42d.jpeg";